var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgShare(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 15,
    height: 17,
    viewBox: "0 0 15 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.5797 11.9985C12.0471 11.9985 11.5636 12.1981 11.1282 12.4981L4.78982 8.74883C4.78982 8.64854 4.8379 8.54918 4.8379 8.49856C4.8379 8.44888 4.8379 8.29891 4.78982 8.24829L11.1282 4.50003C11.5156 4.79997 12.0471 4.99961 12.5797 4.99961C13.934 4.99961 14.9991 3.90015 14.9991 2.4998C14.9991 1.10041 13.935 0 12.5797 0C11.2253 0 10.1602 1.09945 10.1602 2.4998C10.1602 2.60009 10.1602 2.64977 10.2083 2.75007L3.87088 6.50025C3.48351 6.20032 3 6.00068 2.41942 6.00068C1.06503 6.00068 0 7.10013 0 8.50048C0 9.89987 1.0641 11.0003 2.41942 11.0003C2.95193 11.0003 3.43544 10.8006 3.87088 10.5007L10.2092 14.2499C10.2092 14.3502 10.1612 14.3999 10.1612 14.5002C10.1612 15.8996 11.2253 17 12.5806 17C13.935 17 15 15.9005 15 14.5002C14.9991 13.0989 13.9341 11.9985 12.5797 11.9985Z",
    fill: "#FECB48"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgShare);
export default __webpack_public_path__ + "static/media/share.ad4d6ff15724e829c2bdbb081b76b724.svg";
export { ForwardRef as ReactComponent };